<template>
  <div class="fahrzeugschein-upload">
    <!-- Upload Fahrzeugschein -->
    <div class="mb-4">
      <div class="d-sm-flex mb-3">
        <div class="calendar-slot-excerpt d-flex justify-content-start align-items-center" style="margin:0" @click="onToggleRegistrationBox()">
          <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" class="documents-toggle">
            <path d="M24 44.6899C35.0457 44.6899 44 35.7356 44 24.6899C44 13.6442 35.0457 4.68994 24 4.68994C12.9543 4.68994 4 13.6442 4 24.6899C4 35.7356 12.9543 44.6899 24 44.6899Z" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M24 16.6899V32.6899" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" v-if="!showRegistrationBox" />
            <path d="M16 24.6899H32" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div>
            <div class="label-small">Fahrzeugschein<span v-if="required" class="text-danger">*</span>:</div>
            <div class="d-flex justify-content-start align-items-center">
              <div v-if="files_registration.length > 0">
                Sie haben <span class="highlighted">{{ files_registration.length }}</span> Fahrzeugschein(e) erfasst.
              </div>
              <div v-else>
                Sie haben noch keinen Fahrzeugschein erfasst.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters mb-2" v-show="showRegistrationBox">
        <div class="col-sm-5">
          <div class="example-image mb-2" @click="openDropzone()"><img src="/images/ksr/zulassungsbescheinigung-sample.jpg" class="img-fluid" alt="Zulassungsbescheinigung"></div>
        </div>
        <div class="col-sm-7 pl-2 dropzone-wrapper-registration">
          <vue-dropzone ref="myVueDropzone" id="dropzone_fahrzeugschein" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles" @vdropzone-success-multiple="successFiles" @vdropzone-removed-file="removeFile"></vue-dropzone>
          <div class="allowed-filetypes">Erlaubte Dateitypen: .jpg, .png, .pdf, maximale Dateigröße 50MB</div>
        </div>
      </div>
    </div>
    <div id="invalid-registration-required" class="d-block invalid-feedback mb-3" style="margin-top:-10px;" v-if="hasError">
      Bitte erfassen Sie Ihren Fahrzeugschein.
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "KSRFahrzeugscheinUpload",
  components: { vueDropzone: vue2Dropzone },
  props: {
    required: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropzoneOptions: {
        url: '/api/ksr/upload/documents/temp',
        paramName: function(n) {
          return "file[]";
        },
        maxFilesize: 50,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: true,
        parallelUploads: 1,
        acceptedFiles: 'image/*,application/pdf',
        dictDefaultMessage: "Dateien hier ablegen oder Fotos machen",
        dictRemoveFile: "Löschen",
        dictCancelUpload: "Abbrechen",
        dictCancelUploadConfirmation: "Sicher",
        addRemoveLinks: true,
      },
      files_registration: [],
      showRegistrationBox: false
    }
  },
  methods: {
    fileAdded(file) {
      // Construct your file object to render in the UI
    },
    sendingFiles(files, xhr, formData) {
      let uuids = [];
      for(var k = 0; k < files.length; k++) {
        uuids.push(files[k].upload.uuid);
      }
      formData.append('uuids', uuids);
      formData.append('type', 'registration');
    },
    successFiles(files, response) {
      for(var k = 0; k < response.length; k++) {
        this.files_registration.push(response[k]);
        this.showRegistrationBox = false;
      }
      this.$emit('update', this.files_registration);
    },
    removeFile(file, error, xhr) {
      if(file.manuallyAdded) {
        for(var k = 0; k < this.files_registration.length; k++) {
          if(this.files_registration[k] == file.name) {
            this.files_registration.splice(k, 1);
          }
        }
      }
      else {
        let uuidArr = file.upload.uuid.split('-');
        let uuidShort = uuidArr[uuidArr.length - 1];
        for(var k = 0; k < this.files_registration.length; k++) {
          if(this.files_registration[k].includes(uuidShort)) {
            this.files_registration.splice(k, 1);
          }
        }
      }
      this.$emit('update', this.files_registration);
    },
    onToggleRegistrationBox() {
      this.showRegistrationBox = !this.showRegistrationBox;
    },
    openDropzone() {
      document.getElementById('dropzone_fahrzeugschein').click();
    },
    getFiles() {
      return this.files_registration;
    },
    reset() {
      this.files_registration = [];
      if(this.$refs.myVueDropzone) {
        this.$refs.myVueDropzone.removeAllFiles();
      }
    }
  }
};
</script>